//write interface for translations
export interface Translations {
	[key: string]: TranslationObject;
}

export interface TranslationObject {
	noMessages: string;
	loginToView: string;
	notificationCenter: string;
	notificationsLabel: string;
	todayLabel: string;
	yesterdayLabel: string;
	lastSevenDays: string;
	olderLabel: string;
	error: string;
	activateInSettings: string;
	newCategoryAvailable: string;
	autoDeleteAfterTime: string;
	selectCategoryInSettings: string;
}

export const translations: Translations = {
	de: {
		noMessages: "Es liegen derzeit keine Nachrichten für Sie vor.",
		loginToView: "Bitte melden Sie sich an, um Benachrichtigungen zu sehen",
		notificationCenter: "Notification Center ",
		notificationsLabel: "Benachrichtigungen",
		todayLabel: "Heute",
		yesterdayLabel: "Gestern",
		lastSevenDays: "Letzte sieben Tage",
		olderLabel: "Älter",
		error: "Aktuell können keine Benachrichtigungen angezeigt werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.",
		activateInSettings: "Um Benachrichtigungen zu erhalten, aktivieren Sie diese bitte in den Einstellungen",
		newCategoryAvailable: "Eine neue Kategorie {{category}} ist für die Benachrichtigungseinstellungen verfügbar",
		autoDeleteAfterTime: "Die Benachrichtigung wird nach der angezeigten Zeit automatisch gelöscht",
		selectCategoryInSettings: "Um Benachrichtigungen zu erhalten, wählen Sie bitte mindestens eine Kategorie in den Einstellungen.",
	},
	zh: {
		noMessages: "目前没有给您的新信息提示。",
		loginToView: "请登录以查看通知",
		notificationCenter: "通知中心 ",
		notificationsLabel: "通知",
		todayLabel: "今天",
		yesterdayLabel: "昨天",
		lastSevenDays: "过去七天",
		olderLabel: "更早",
		error: "目前无法显示任何通知。请稍后重试。",
		activateInSettings: "若要接收通知，请在设置中将其激活",
		newCategoryAvailable: "通知设置可使用新布局 {{category}} ",
		autoDeleteAfterTime: "显示的时间过后，通知会自动删除",
		selectCategoryInSettings: "如要获得通知，请在设置中至少选择一个布局。",
	},
	en: {
		noMessages: "There are currently no messages for you.",
		loginToView: "Please sign in to see notifications",
		notificationCenter: "Notification Center ",
		notificationsLabel: "Notifications",
		todayLabel: "Today",
		yesterdayLabel: "Yesterday",
		lastSevenDays: "Last seven days",
		olderLabel: "Older",
		error: "Currently no notifications can be displayed. Please try again later.",
		activateInSettings: "To receive messages, please activate this in Settings",
		newCategoryAvailable: "A new {{category}} is available for the message settings",
		autoDeleteAfterTime: "The notification is automatically deleted after the time indicated",
		selectCategoryInSettings: "To receive notifications please select at least one category in Settings.",
	},
	fr: {
		noMessages: "Vous n'avez actuellement aucun message.",
		loginToView: "Veuillez vous identifier pour voir les notifications.",
		notificationCenter: "Centre de notifications",
		notificationsLabel: "Notifications",
		todayLabel: "Aujourd'hui",
		yesterdayLabel: "Hier",
		lastSevenDays: "Sept derniers jours",
		olderLabel: "Date plus ancienne",
		error: "Aucune notification ne peut être affichée actuellement. Veuillez réessayer ultérieurement.",
		activateInSettings: "Pour recevoir des notifications, veuillez les activer dans les réglages",
		newCategoryAvailable: "Une nouvelle catégorie {{category}} est disponible pour les réglages de notifications",
		autoDeleteAfterTime: "La notification est supprimée automatiquement après expiration du délai indiqué.",
		selectCategoryInSettings: "Pour recevoir des notifications, veuillez sélectionner au moins une catégorie dans les réglages.",
	},
	it: {
		noMessages: "Al momento non ci sono messaggi.",
		loginToView: "Effettua il login per visualizzare le notifiche",
		notificationCenter: "Centro notifiche",
		notificationsLabel: "Notifiche",
		todayLabel: "Oggi",
		yesterdayLabel: "Ieri",
		lastSevenDays: "Ultimi sette giorni",
		olderLabel: "Precedenti",
		error: "Al momento non possono essere visualizzate notifiche. Riprova in un momento successivo.",
		activateInSettings: "Per ricevere gli avvisi, attiva l'opzione nelle impostazioni",
		newCategoryAvailable: "È disponibile una nuova categoria {{category}} per le impostazioni degli avvisi",
		autoDeleteAfterTime: "La notifica viene eliminata automaticamente dopo il tempo indicato",
		selectCategoryInSettings: "Per ricevere gli avvisi, seleziona almeno una categoria nelle impostazioni.",
	},
	ko: {
		noMessages: "현재 새 메시지가 없습니다.",
		loginToView: "알림을 보려면, 로그인하십시오.",
		notificationCenter: "알림 센터",
		notificationsLabel: "알림",
		todayLabel: "오늘",
		yesterdayLabel: "어제",
		lastSevenDays: "지난 7일간",
		olderLabel: "이전",
		error: "현재 알림을 표시할 수 없습니다. 나중에 다시 시도하십시오.",
		activateInSettings: "알림을 받으시려면 설정에서 알림을 활성화하십시오",
		newCategoryAvailable: "알림 설정을 위해 새로운 카테고리{{category}}를 사용할 수 있습니다",
		autoDeleteAfterTime: "알림은 표시된 시간이 지나면 자동으로 삭제됩니다",
		selectCategoryInSettings: "알림을 받으시려면 설정에서 카테고리를 한 개 이상 선택해 주세요.",
	},
	nl: {
		noMessages: "Er zijn momenteel voor u geen meldingen.",
		loginToView: "Meld u aan om meldingen weer te geven",
		notificationCenter: "Berichtencentrum",
		notificationsLabel: "Meldingen",
		todayLabel: "Vandaag",
		yesterdayLabel: "Gisteren",
		lastSevenDays: "Afgelopen zeven dagen",
		olderLabel: "Ouder",
		error: "Momenteel kunnen er geen berichten worden weergegeven. Probeer het op een later tijdstip opnieuw.",
		activateInSettings: "Om berichten te ontvangen moet u dit activeren in de Instellingen",
		newCategoryAvailable: "Een nieuwe categorie {{category}} is beschikbaar voor de instellingen om berichten te ontvangen",
		autoDeleteAfterTime: "Het bericht wordt na de weergegeven tijd automatisch gewist",
		selectCategoryInSettings: "Om berichten te ontvangen, selecteert u minimaal een categorie in de instellingen.",
	},
	pl: {
		noMessages: "Obecnie nie mają Państwo żadnych wiadomości.",
		loginToView: "Proszę się zalogować, aby zobaczyć powiadomienia.",
		notificationCenter: "Centrum powiadomień",
		notificationsLabel: "Powiadomienia",
		todayLabel: "Dzisiaj",
		yesterdayLabel: "Wczoraj",
		lastSevenDays: "Ostatnie siedem dni",
		olderLabel: "Starsze",
		error: "Aktualnie nie można wyświetlić żadnych powiadomień. Proszę spróbować ponownie później.",
		activateInSettings: "Aby otrzymywać powiadomienia, należy aktywować je w ustawieniach",
		newCategoryAvailable: "Dostępna jest nowa kategoria {{category}} dla ustawień powiadomień",
		autoDeleteAfterTime: "Powiadomienie zostanie automatycznie usunięte po upływie wskazanego czasu",
		selectCategoryInSettings: "Aby otrzymywać powiadomienia, należy wybrać co najmniej jedną kategorię w ustawieniach.",
	},
	es: {
		noMessages: "Actualmente no hay mensajes nuevos para ti.",
		loginToView: "Inscríbete para ver las notificaciones",
		notificationCenter: "Centro de notificaciones ",
		notificationsLabel: "Notificaciones",
		todayLabel: "Hoy",
		yesterdayLabel: "Ayer",
		lastSevenDays: "Última semana",
		olderLabel: "Anteriores",
		error: "Actualmente, no se pueden mostrar notificaciones. Por favor, inténtalo de nuevo más tarde.",
		activateInSettings: "Para poder recibir notificaciones, tienes que activarlas en los ajustes",
		newCategoryAvailable: "Hay una nueva categoría {{category}} disponible para los ajustes de notificaciones",
		autoDeleteAfterTime: "La notificación se borrará automáticamente una vez transcurrido el tiempo estipulado",
		selectCategoryInSettings: "Para recibir notificaciones, seleccione al menos una categoría en los ajustes.",
	},
	cs: {
		noMessages: "Nyní pro Vás nejsou k dispozici žádná nová hlášení.",
		loginToView: "Přihlaste se prosím, abyste viděli zprávy",
		notificationCenter: "Notifikační centrum ",
		notificationsLabel: "Zprávy",
		todayLabel: "Dnes",
		yesterdayLabel: "Včera",
		lastSevenDays: "Za posledních sedm dní",
		olderLabel: "Starší",
		error: "Aktuálně nelze zobrazit žádné zprávy. Zkuste to později znovu.",
		activateInSettings: "Abyste obdrželi oznámení, aktivujte je v nastaveních",
		newCategoryAvailable: "Pro nastavení oznámení je k dispozici nová kategorie {{category}}",
		autoDeleteAfterTime: "Zpráva bude po zobrazené době automaticky vymazána.",
		selectCategoryInSettings: "Abyste obdrželi oznámení, zvolte prosím v nastaveních minimálně jednu kategorii.",
	},
	hu: {
		noMessages: "Jelenleg Önnek nincsenek új üzenetei.",
		loginToView: "Kérjük, jelentkezzen be az értesítések megtekintéséhez",
		notificationCenter: "Értesítési központ ",
		notificationsLabel: "Értesítések",
		todayLabel: "Ma",
		yesterdayLabel: "Tegnap",
		lastSevenDays: "Utolsó hét nap",
		olderLabel: "Régebbi",
		error: "Jelenleg nem jeleníthetők meg értesítések. Kérjük, próbálja meg újra egy későbbi időpontban.",
		activateInSettings: "Ha szeretne értesítéseket kapni, aktiválja azokat a beállításokban.",
		newCategoryAvailable: "Új elrendezés {{category}} áll rendelkezésre az értesítések beállításaihoz",
		autoDeleteAfterTime: "Az értesítés a kijelzett idő elteltével törlődik",
		selectCategoryInSettings: "Ha szeretne értesítéseket kapni, akkor válasszon ki legalább egy elrendezést a beállításokban.",
	},
	zh_TW: {
		noMessages: "目前沒有給您的訊息。",
		loginToView: "請登入查看訊息",
		notificationCenter: "通知中心",
		notificationsLabel: "訊息",
		todayLabel: "現在",
		yesterdayLabel: "昨天",
		lastSevenDays: "最近七天",
		olderLabel: "更早",
		error: "目前無法顯示任何訊息。請稍後重新嘗試。",
		activateInSettings: "如要接收訊息，請在設定中將其啟用",
		newCategoryAvailable: "訊息設定新增類別 {{category}}",
		autoDeleteAfterTime: "訊息會在顯示時間後自動刪除",
		selectCategoryInSettings: "如要接收訊息，請在設定中至少選擇一個類別。",
	},
	ja: {
		noMessages: "現在、お客様宛の通知はありません。",
		loginToView: "通知を見るにはログインしてください",
		notificationCenter: "通知センター",
		notificationsLabel: "通知",
		todayLabel: "今日",
		yesterdayLabel: "昨日",
		lastSevenDays: "過去７日",
		olderLabel: "それ以前",
		error: "現在、通知を表示できません。後ほどもう一度お試しください。",
		activateInSettings: "通知を受け取るには、設定で通知を有効にしてください",
		newCategoryAvailable: "通知設定に新しいカテゴリー　{{category}}　ができました。",
		autoDeleteAfterTime: "通知は、表示時間後に自動的に削除されます。",
		selectCategoryInSettings: "通知を受け取るには、設定で少なくとも1件はカテゴリーを選択してください。",
	},
	pt: {
		noMessages: "De momento não existem avisos para si.",
		loginToView: "Registe-se para visualizar as notificações",
		notificationCenter: "Notification Center ",
		notificationsLabel: "Notificações",
		todayLabel: "Hoje",
		yesterdayLabel: "Ontem",
		lastSevenDays: "Últimos sete dias",
		olderLabel: "Mais antigo",
		error: "No momento não é possível mostrar notificações. Por favor, tente novamente mais tarde.",
		activateInSettings: "Para receber notificações, ative-as nas definições",
		newCategoryAvailable: "Está disponível uma nova categoria {{category}} para as definições de notificações",
		autoDeleteAfterTime: "A notificação é eliminada automaticamente após o tempo indicado",
		selectCategoryInSettings: "Pare receber notificações, selecione pelo menos uma categoria nos ajustes.",
	},
};
